// packages
import { renderSvelteComponent } from './render.js';

//components
import TwoColumnList from '../components/TwoColumnList.svelte';

/**
 * Renders a legislature results table into its container.
 * Uncalled tables are filtered before this, in mountLegislature (excludeIds).
 * @param {HTMLElement} container - The embed's box
 * @param {import('svelte/store').Readable<import('../types').Race[]>} feed - The races to show
 */
export function findAndRenderRaceResultElements(container, feed) {
  renderSvelteComponent(TwoColumnList, container, {
    races: feed,
  });
}
